// src/App.jsx
import React, { Suspense } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';

import Header from './components/Header/jsx/Header';
import Footer from './components/Footer/jsx/Footer';
import HomePage from './pages/HomePage/jsx/HomePage';
import NewMenuPage from './components/NewMenu/NewMenuPage';
import LocationPage from './pages/LocationPage/jsx/LocationPage';
import AboutPage from './pages/AboutPage/jsx/AboutPage';
import ReservationModal from './components/Reservation/ReservationModal';

import './App.css';

function Loader() {
  return <div className="vt-loader" aria-live="polite">Loading…</div>;
}

export default function App() {
  return (
    <Suspense fallback={<Loader />}>
      <LanguageProvider>
        <Header />
        <main>
          <section id="home">
            <HomePage />
          </section>

          <div className="divider-container" />

          <section id="about">
            <AboutPage />
          </section>

          {/* Don't wrap with another <section id="menu">.
              NewMenuPage itself renders <section id="menu"> */}
          <NewMenuPage />

          <div className="divider-container" />

          <section id="location">
            <LocationPage />
          </section>
        </main>

        {/* Global reservation modal (opened by homepage Reserve button) */}
        <ReservationModal />

        <Footer />
      </LanguageProvider>
    </Suspense>
  );
}
